import ReactDOM from "react-dom/client";
import "react-toastify/dist/ReactToastify.css"; //CSS Style

import App from "./App";
import "./index.css";

import reportWebVitals from "./reportWebVitals";

import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);

if (process.env.REACT_APP_ENV === "PRD") {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {}; // Optional: Disable other console methods if needed
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
